module.exports = __webpack_public_path__ + "img/ic-home-active.ac56ca68.svg";